import { RichTextContent } from 'types'
import { UnixTime } from 'types/measurement/time'
import {
  RolodexEntryJson,
  RolodexEntryType,
} from 'types/rolodex/rolodexEntries'
import { parseNumber, parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

export type UserComment = {
  user_id: string
  user_name: string | undefined
  timestamp: UnixTime
  text: RichTextContent
  reply_comment_id?: string // Putting this in the data, since tags are not supposed to self-reference the type
}

export class GeckoUserComment extends GeckoEntryBase<
  UserComment,
  {
    organization: string
    site: string
    [RolodexEntryType.CASE]?: string
  }
> {
  private constructor(json: RolodexEntryJson) {
    super(
      json,
      {
        user_id: parseString(json.data.user_id) ?? 'unknown',
        user_name: parseString(json.data.user_name),
        timestamp: parseNumber(json.data.timestamp) as UnixTime,
        text: parseString(json.data.text) as RichTextContent,
        reply_comment_id: parseString(json.data.reply_comment_id),
      },
      {
        organization: parseString(json.tags.organization) ?? '',
        site: parseString(json.tags.site) ?? '',
        [RolodexEntryType.CASE]: parseString(json.tags[RolodexEntryType.CASE]),
      },
      {}
    )
  }

  public static CreateFromJSON(json: RolodexEntryJson): GeckoUserComment {
    return new GeckoUserComment(json)
  }
}
